<!-- About Start -->
<div *ngIf="submenu == 'offre-de-formation'">
    <div class="container-xxl about " style=" background: linear-gradient(rgba(0, 0, 0, .1), rgba(0, 0, 0, .1)), url(assets/img/a.svg) left center no-repeat;
                        background-size: cover;">
        <div class="container">
            <div class="row g-0">
                <div class="col-lg-6">
                    <div class="h-100 d-flex align-items-center justify-content-center" style="min-height: 300px;">
                        <h1 class="customize-title" style="color: white;">Nos offres de formations </h1>
                    </div>
                </div>
                <div class="col-lg-6 pt-lg-3 mb-lg-5 wow fadeIn" data-wow-delay="0.5s">
                    <div class="bg-white rounded-top p-5 mt-lg-5">
                        <p class="fs-5 fw-medium" style="color: #FF5A00;">Formation = Investissement</p>
                        <p class=" mb-2" style="font-size: 15px !important  ;">Nous vous offrons des formations adaptées
                            à
                            vos besoins. Nos formations sont délivrées dans des conditions optimales par
                            des professionnels références dans leurs domaines</p>


                        <a class="btn  rounded-pill py-3 px-5" style="background-color: #FF5A00; color: white;"
                            href="assets/docs/Catalogue_de_formation.pdf" target="_blank">Catalogue de formation</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- About End -->
    <section class="ett" style="margin:50px auto;">
        <div class="container">

            <div class="row">
                <div class="col-12 col-sm-5 col-lg-5"><img style="width: 100%; border-radius: 15px;"
                        src="assets/img/train_illustration.jpg">
                </div>
                <div class="col-12 col-sm-6 col-lg-6" style="margin: auto;">
                    <h2 class="customize-title" style="color: #00027D;">Talents Plus Conseils </h2>
                    <p>La stratégie de formation utilisée par TPC est en grande partie les règles de formation des
                        adultes :
                        La démarche de
                        formation de TPC est basée sur les règles de l’andragogie. <br> <br>
                        <a class="btn  rounded-pill py-3 px-5" style="background-color: #FF5A00; color: white;"
                            href="assets/docs/Calendrier 2eme trimestre 2023.pdf" target="_blank">Calendrier 2ème
                            trimestre 2023</a>

                </div>
            </div>
        </div>
    </section>

    <section class="testimonials"
        style="padding: 10px 0px 10px; background: url('assets/img/back-pays.svg'); background-size: cover; background-position: center; background-repeat: no-repeat;">
        <div class="container p-3">
            <h2 class="customize-title mb-3 text-white" style="text-align: center !important;">Nos certifications et
                agréments</h2>
            <div class="row">
                <div class="col-lg-4  col-12 col-sm-6 " style="display: flex;
    align-items: center;">
                    <img src="assets/img/interteck.png" alt="">
                </div>
                <div class="col-lg-8  col-12 col-sm-6 ">
                    <p class="text-justify text-white"><b>Les prestations de formations de Talents Plus Conseils Bénin
                            ont
                            reçu la
                            certification qualité ISO
                            29993 V 2017 –
                            Qualité des organismes de formation.</b>ISO 29993 V 2017 est le gage de qualité d’un
                        référentiel
                        rigoureux reconnu à
                        l’international. C’est,
                        dorénavant, votre
                        critère objectif supplémentaire qui justifie votre préférence et votre confiance en la qualité
                        et en
                        l’efficacité de nos
                        ateliers de formation. Cette certification des services de formation de Talents Plus Conseils
                        est
                        délivrée par <b>INTERTEK</b></p>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-8  col-12 col-sm-6 ">
                    <p class="text-justify text-white">Le Cabinet est également habilité comme Centre de Formation
                        Professionnelle
                        Continue par le MTFP à
                        travers la Direction
                        Générale de Renforcement des Capacités et de l'Employabilité (DGRCE) et le Fonds de
                        Développement de
                        la Formation
                        Professionnelle Continue et de l'Apprentissage (FODEFCA).</p>
                </div>
                <div class="col-lg-4  col-12 col-sm-6 " style="display: flex;
    align-items: center;">
                    <img src="assets/img/part.jpg" alt="">
                </div>
            </div>
        </div>
    </section>

    <section class="ett" style="margin:50px auto;">
        <div class="container">

            <div class="row">

                <div class="col-12 col-sm-6 col-lg-6">
                    <!-- <h2 class="customize-title" style="color: #00027D;">Talents Plus Conseils </h2> -->
                    <p class="text-blue" style="text-align: justify;"> Ce sont les prestations du département
                        formation qui ont permis à
                        TPC Bénin d’être habilité par le Fonds de
                        Développement de la Formation Professionnelle Continue et de l’Apprentissage (FODEFCA).
                        Cette habilitation facilite le
                        recours à ses prestations par les entreprises éligibles au financement du FODEFCA. <br> <br>
                        Afin de contribuer à l’amélioration des
                        performances dans ses entreprises clientes, le cabinet TALENTS PLUS CONSEILS a
                        choisi le volet formation comme un axe majeur et ambitionne de devenir un centre de
                        formation de référence. Dans cette
                        optique, le cabinet s’est engagé dans la démarche de la certification de son produit «
                        Formation » suivant la norme ISO
                        29993 V2017 avec l’appui technique et financier du <span style="font-weight:bold;"> PAORC
                            - Coopération Technique Belge
                            (Enabel)</span>. Ce projet a été
                        concrétisé par sa certification le 12 septembre 2018 suite à l’audit initial réalisé par
                        Intertek les 05 et 06 juillet
                        2018. <br> <br>
                        Dans sa Politique Qualité,
                        le Département Formation du Cabinet énumère les raisons qui fondent la migration vers cette
                        norme. Conformément à cette Politique Qualité, le système ISO permet :
                    </p>
                    <a class="btn  rounded-pill py-3 px-5" style="background-color: #FF5A00; color: white;"
                        href="assets/docs/Calendrier 2eme trimestre 2023.pdf" target="_blank">Calendrier 2ème
                        trimestre 2023</a>

                </div>
                <div class="col-12 col-sm-5 col-lg-6"
                    style="display: flex;flex-direction: column; align-items: center;">
                    <p class="text-blue "> <span style="font-weight:bold;">
                            <ul style="font-weight:bold;">
                                <li> <i class="fa fa-hand-o-right mr-2 " aria-hidden="true"></i> d’améliorer la
                                    prise en compte des besoins en formation des parties prenantes à
                                    travers l’étude diagnostic desdits besoins </li>
                                <li> <i class="fa fa-hand-o-right mr-2 " aria-hidden="true"></i> d’utiliser des
                                    formateurs répondant aux méthodes du Cabinet et à l’andragogie
                                </li>
                                <li> <i class="fa fa-hand-o-right mr-2 " aria-hidden="true"></i> d’axer la démarche
                                    de formation sur le retour sur investissement (ROI) </li>
                                <li> <i class="fa fa-hand-o-right mr-2 " aria-hidden="true"></i> d’évaluer les
                                    connaissances des acteurs afin de prévoir les actions préventives
                                    et
                                    correctives </li>
                                <li> <i class="fa fa-hand-o-right mr-2 " aria-hidden="true"></i> de faire des
                                    clients des acteurs principaux des contenus développés et de leur
                                    transfert en entreprise </li>
                                <li> <i class="fa fa-hand-o-right mr-2 " aria-hidden="true"></i> de développer des
                                    partenariats gagnant-gagnant avec les interlocuteurs</li>
                            </ul>
                        </span>
                    </p>
                    <img style="width: 82%; border-radius: 15px;" src="assets/img/training_photo.jpg">
                </div>
            </div>
        </div>
    </section>

    <section class="about-section section-padding"
        style="padding: 20px 0px 20px; background: url('assets/img/back-about.svg'); background-size: cover; background-position: center; background-repeat: no-repeat;"
        id="section_2">
        <div class="container">
            <div class="row">
                <div class="col-lg-6 col-12 ">
                    <div class="services-info">
                        <p class="section-title"></p>
                        <p class="text-blue ">
                            Dans ce cadre, la Direction s’est engagée à mettre à disposition toutes les
                            ressources
                            nécessaires pour la mise en œuvre
                            et la pérennisation du système de management de qualité.
                            A cet effet, le Département Formation est tenu de réaliser les objectifs suivants :
                        </p>
                    </div>
                    <img style="width: 82%; border-radius: 15px;" src="assets/img/online.jpg">
                </div>
                <div class="col-lg-6 col-12 ">
                    <ul class="text-blue " style="font-weight:bold;">
                        <li> <i class="fa fa-hand-o-right mr-2 " aria-hidden="true"></i> Pouvoir déterminer les
                            besoins de formation dans un délai d’une semaine au maximum
                            après
                            la transmission des données
                            par le client </li>
                        <li> <i class="fa fa-hand-o-right mr-2 " aria-hidden="true"></i> Réaliser l’évaluation à
                            chaud de toutes les actions de formation et envoyer un rapport
                            au
                            client </li>
                        <li><i class="fa fa-hand-o-right mr-2 " aria-hidden="true"></i> Respecter à 70 % au moins le
                            rapport qualité/prix dans les offres de services de
                            formation
                        </li>

                        <li> <i class="fa fa-hand-o-right mr-2 " aria-hidden="true"></i> Respecter à 70 % au moins
                            la flexibilité imposée par l’entreprise quant aux modalités de
                            livraison (lieu, période,
                            durée) </li>
                        <li> <i class="fa fa-hand-o-right mr-2 " aria-hidden="true"></i> Répondre à toute demande
                            d’un client sous 72 heures au maximum </li>
                        <li><i class="fa fa-hand-o-right mr-2 " aria-hidden="true"></i> Mettre à la disposition des
                            clients, des formateurs qualifiés, évalués à partir du
                            référentiel de formation élaboré
                            par ceux-ci </li>
                        <li> <i class="fa fa-hand-o-right mr-2 " aria-hidden="true"></i> Limiter à 5 % au plus les
                            risques liés à l’organisation logistique de la formation</li>
                        <li> <i class="fa fa-hand-o-right mr-2 " aria-hidden="true"></i> Il s’agit là des volets
                            d’indicateurs à calculer et à améliorer au jour le jour</li>
                    </ul>
                </div>


            </div>
        </div>
    </section>
</div>

<div *ngIf="submenu == 'formations-intraentreprises'">
    <div class="container-xxl about " style=" background: linear-gradient(rgba(0, 0, 0, .1), rgba(0, 0, 0, .1)), url(assets/img/a.svg) left center no-repeat;
                        background-size: cover;">
        <div class="container" style="padding: 100px 0px 100px 0px;">
            <div class="row g-0">
                <h1 class="text-white font-weight-bold" style="    font-size: 2.5rem !important;">Formations
                    Intra-entreprises
                </h1>

            </div>
        </div>
    </div>
    <!-- About End -->
    <section class="ett">
        <div class="container">
            <div class="alert alert-primary mt-3" role="alert">
                Les formations sont classées PAR SECTEUR ET PAR METIER.
            </div>


            <div class="row mb-5">

                <div class="col-12 col-sm-5 col-lg-5"><img style="width: 100%; border-radius: 15px;"
                        src="assets/img/img-ett-2.jpg">
                </div>
                <div class="col-12 col-sm-6 col-lg-6" style="margin: auto;">
                    <p class=" "> <span style="font-weight:; font-size: large;">
                            <ul style="font-weight: ;">
                                <li> <i class="fa fa-hand-o-right mr-2 " aria-hidden="true"></i>SECRETARIAT-FONCTION DE
                                    SUPPORT- LANGUE ET TIC </li>
                                <li> <i class="fa fa-hand-o-right mr-2 " aria-hidden="true"></i>
                                    LEADERSHIP-MANAGEMENT-GRH
                                </li>
                                <li> <i class="fa fa-hand-o-right mr-2 " aria-hidden="true"></i> ADMINISTRATION PUBLIQUE
                                    ET TERRITORIALE </li>
                                <li> <i class="fa fa-hand-o-right mr-2 " aria-hidden="true"></i> AUDIT -COMPTABILITE
                                    MARKETING ET FISCALITE </li>
                                <li> <i class="fa fa-hand-o-right mr-2 " aria-hidden="true"></i> BANQUE - ASSURANCE
                                </li>
                                <li> <i class="fa fa-hand-o-right mr-2 " aria-hidden="true"></i> INDUSTRIE ET PETROLIER
                                    ET BTP</li>
                            </ul>
                        </span>
                    </p>

                </div>
            </div>
        </div>
    </section>

    <section class="testimonials"
        style="padding: 20px 0px 20px; background: url('assets/img/back-about.svg'); background-size: cover; background-position: center; background-repeat: no-repeat;">
        <div class="container p-3">
            <h2 class="customize-title mb-3 " style="text-align: center !important;">Nos certifications et
                agréments</h2>
            <div class="row">
                <div class="col-lg-4  col-12 col-sm-6 " style="display: flex;
    align-items: center;">
                    <img src="assets/img/interteck.png" alt="">
                </div>
                <div class="col-lg-8  col-12 col-sm-6 ">
                    <p class="text-justify "><b>Les prestations de formations de Talents Plus Conseils Bénin
                            ont
                            reçu la
                            certification qualité ISO
                            29993 V 2017 –
                            Qualité des organismes de formation.</b>ISO 29993 V 2017 est le gage de qualité d’un
                        référentiel
                        rigoureux reconnu à
                        l’international. C’est,
                        dorénavant, votre
                        critère objectif supplémentaire qui justifie votre préférence et votre confiance en la qualité
                        et en
                        l’efficacité de nos
                        ateliers de formation. Cette certification des services de formation de Talents Plus Conseils
                        est
                        délivrée par <b>INTERTEK</b></p>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-8  col-12 col-sm-6 ">
                    <p class="text-justify ">Le Cabinet est également habilité comme Centre de Formation
                        Professionnelle
                        Continue par le MTFP à
                        travers la Direction
                        Générale de Renforcement des Capacités et de l'Employabilité (DGRCE) et le Fonds de
                        Développement de
                        la Formation
                        Professionnelle Continue et de l'Apprentissage (FODEFCA).</p>
                </div>
                <div class="col-lg-4  col-12 col-sm-6 " style="display: flex;
    align-items: center;">
                    <img src="assets/img/part.jpg" alt="">
                </div>
            </div>
        </div>
    </section>


</div>